import React, { useState, useEffect, useContext, useMemo } from "react";
import URLstateContext from "../../../provider/CommonContext";
import { Col, Container, Row } from 'react-bootstrap';
import './BulkDeals.css';
import Pagination from '../../CommonUI/Pagination/Pagination';
import { useLocalStorage } from "../../utils/useLocalStorage";
import MarketEquity from "../MarketEquity";
import { Vortex } from 'react-loader-spinner';
import CallTrackApi from "../../Activity_Track/CallTrackApi";

function BulkDeals() {
    const [cocode, setcocode] = useLocalStorage("cocode", "");
    let optionInfoMarket = "Bulk Deals";
    let optionTypeComp = "Daily Market Tracker";
    const [data, setData] = useState([]);
    const [dataGroup, setDataGroup] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [groupValue, setGroupValue] = useState("BSE");
    const [valueLy, setValueLy] = useState("10");
    const [groupIndex, setGroupIndex] = useState("Bulk");
    const [loadingshow, setloadingshow] = useState(false);
    // const [groupIndexNSE, setGroupIndexNSE] = useState("NIFTY");
    const { BaseURL } = useContext(URLstateContext);
    let getData, getDataGroup, eleBtn, eleBtnLoose, eleLi;
    let PageSize = 8;


    useEffect(() => {
        setloadingshow(true);
        if (groupValue === "BSE") {
            const getUrl = BaseURL + "BulkDeals";

            fetch(`${getUrl}/${groupValue}/${groupIndex}/10`)
                .then((response) => response.json())
                .then((data) => {
                    getData = data.data;
                    setData(getData);
                    //  console.log(getData, "getDataBSE")
                    setloadingshow(false);
                })
                .catch((error) => {
                });
        }
        else {
            const getUrl = BaseURL + "BulkDeals";
            fetch(`${getUrl}/${groupValue}/${groupIndex}/10`)
                .then((response) => response.json())
                .then((data) => {
                    getData = data.data;
                    setData(getData);
                    // console.log(getData, "getData")
                    setloadingshow(false);
                })
                .catch((error) => {
                });
        }

        const getUrlGroup = BaseURL + "GroupMaster";
        fetch(`${getUrlGroup}/${groupValue}`)
            .then((response) => response.json())
            .then((dataG) => {
                getDataGroup = dataG.data;
                setDataGroup(getDataGroup);
                //console.log(getDataGroup, "getDataGroup")
            })
            .catch((error) => {
            });

    }, [groupValue, valueLy, groupIndex]);





    const currentTableData = useMemo(() => {
        if (data != null && data != []) {
            const firstPageIndex = (currentPage - 1) * PageSize;
            const lastPageIndex = firstPageIndex + PageSize;
            if (data != null && data != []) {
                if (data.length > 0) {
                    return data.slice(firstPageIndex, lastPageIndex);
                }
            }
        }
    }, [currentPage, data]);
    const routeChange = (event) => {
        const compcocode = event.currentTarget.dataset.id;
        const compcode_array = compcocode.split('-');
        const getCoCodeId = compcode_array[0].replace(/ /g, '-').replace('&', 'and').replace('+', '');
        setcocode(compcode_array[1]);
        window.open("/stocks/" + getCoCodeId.toLowerCase(), '_blank');
    };
    CallTrackApi("Bulk Deals",window.location.href);

    return (
        <>
            <div class="col-12 p-0 breadcrum ">
                <ul>
                    <li><a href="/">Home</a> <i class="fa fa-angle-right" aria-hidden="true"></i></li>
                    <li><a href="/market/stocks">Stocks</a> <i class="fa fa-angle-right" aria-hidden="true"></i></li>
                    <li>Bulk Deals</li>
                </ul>
            </div>
            <Container>
                <Row>
                    <Col sm={12}>
                        <section className='gainer-loser-sc'>
                            <div className='gainer-header'>
                                <h2><span>Bulk Deals</span></h2>
                            </div>
                            <MarketEquity optionInfoMarket={optionInfoMarket} optionTypeComp={optionTypeComp} />
                            <div className='gainer-table-main'>
                                <div className='exchange-right exchange'>
                                    <div className='holidays-inner-select'>
                                        
                                        {/* aria-label="nse bse" */}
                                        <select aria-label="nse bse" onChange={(event) => { setGroupValue(event.target.value); }}>

                                            <option value="BSE" selected>BSE</option>
                                            <option value="NSE">NSE</option>

                                        </select>
                                    </div>


                                </div>

                                {/* < hr className="hrBulk"></hr> */}
                                <div className='exchange-table table-responsive'>
                                    <table className='table'>
                                        <thead>
                                            <tr>
                                                <th className='text-left' rowspan="2">Company Name</th>
                                                <th className='text-right' rowspan="2">Date</th>


                                                <th className='text-right' rowspan="2">NSE symbol</th>
                                                <th className='text-left' rowspan="2">Client Name</th>
                                                <th className='text-left' rowspan="2">Deal Type</th>
                                                <th className='text-right' rowspan="2">Quantity(No’s)</th>
                                                <th className='text-right' rowspan="2">price(&#8377;)</th>



                                            </tr>
                                        </thead>

                                        <tbody>
                                            {(groupValue === "BSE" ) ?
                                            currentTableData && currentTableData.map(
                                                ({ scripname, date, scripcode, clientname, BUYSELL, qtyshares, avg_price, CO_CODE }) => (
                                                    <tr>
                                                        <td className='text-left'>{scripname}</td>
                                                        <td className='text-right'> {(date != null) ? date.split('T')[0]:''}</td>
                                                        <td className='text-right'> {scripcode}</td>
                                                        <td className='text-left nameClient'> {clientname}</td>
                                                        <td className="text-left"> {BUYSELL}</td>
                                                        <td className='text-right'> {qtyshares}</td>
                                                        <td className='text-right'> {(avg_price != null) ? avg_price.toFixed(2) : 0}</td>
                                                    </tr>
                                                )) : 
                                                currentTableData && currentTableData.map(
                                                    ({ ScripName, Date, scripcode, ClientName, BUYSELL, qtyshares, avg_price, CO_CODE }) => (
                                                        <tr>
                                                            <td className='text-left'>{ScripName}</td>
                                                            <td className='text-left'> {(Date != null)? Date.split('T')[0]:''}</td>
                                                            <td className='text-left'> {scripcode}</td>
                                                            <td className='text-left nameClient'> {ClientName}</td>
                                                            <td className="text-left"> {BUYSELL}</td>
                                                            <td className='text-right'> {qtyshares}</td>
                                                            <td className='text-right'> {(avg_price != null) ? avg_price.toFixed(2) : 0}</td>
                                                        </tr>
                                                    ))}
                                               
                                        </tbody>
                                    </table>
                                    {loadingshow ? <div className="textcentervertex">
                                        <Vortex
                                            visible={true}
                                            height="80"
                                            width="80"
                                            ariaLabel="vortex-loading"
                                            wrapperStyle={{}}
                                            wrapperClass="vortex-wrapper"
                                            colors={['#0473ea', '#0473ea', '#0473ea', '#39d800', '#39d800', '#39d800']}
                                        />
                                        <div className="model_popup">Please Wait...</div>
                                    </div> : ""
                                    }
                                </div>
                                {(data != null && data != []) ?
                                    <Pagination
                                        className="pagination-bar_peer"
                                        currentPage={currentPage}
                                        totalCount={(data.length != null) ? data.length : 0}
                                        pageSize={PageSize}
                                        onPageChange={page => setCurrentPage(page)}
                                    /> : <p className="errorPeer"> No Data Found !!! </p>}
                            </div>
                        </section>
                    </Col>
                </Row>
            </Container>
        </>
    );
}

export default BulkDeals;